export const BREAKPOINT = {
  SMALL: 576,
  MEDIUM: 768,
};
